import React from 'react';
import VerifyForm from './VerifyForm';


class VerifyCreate extends React.Component {

    render(){
        return (
            <div>
                <VerifyForm />
            </div>
        );
    }

}
export default VerifyCreate;



// WEBPACK FOOTER //
// ./src/pages/Verify/VerifyCreate.js